import {
    type FC
} from "react";
import type IDropdownMenuShortcutProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    useDropdownMenuContext
} from "../../context";
import {
    getDropdownMenuShortcut
} from "../../util";
import {
    getKbdPlatform
} from "../../../kbd/util";
import Kbd from "../../../kbd";

const DropdownMenuShortcut: FC<IDropdownMenuShortcutProps> = ({
    customTheme: customThemeProp,
    style,
    keys
}) => {
    const context = useDropdownMenuContext({
        part: "Shortcut"
    });

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    const shortcut = getDropdownMenuShortcut({
        platform: getKbdPlatform(),
        localize,
        keys
    });

    return <Kbd
        customTheme={customThemeProp ?? context?.customTheme}
        customLocalize={context?.customLocalize}
        displayBehaviour="always"
        style={[
            style,
            stylesheet.shortcut
        ]}
        keys={shortcut.labels}
        aria-hidden={true}
        separator="auto"
        variant="ghost"
    />;
};
export default DropdownMenuShortcut;
